





















































import Vue from "vue";
import _ from "lodash";
export default Vue.extend({
  props: {
    validatePath: String,
    savePath: String,
    noConfirmation: Boolean,
    input: Object,
    postDataDecorator: Function,
    saveMethod: {
      type: String,
      default: "post"
    }
  },
  data() {
    return {
      isLoading: false,
      violations: {},
      phase: "input",
      // inputData: this.$props.input
    };
  },
  computed: {
    inputData() {
      return this.$props.input;
    },
    hasViolations() {
      const violations = JSON.parse(JSON.stringify(this.$data.violations));
      return !!Object.keys(violations).length;
    }
  },
  methods: {
    onFieldInput(path: string, value: unknown) {
      _.set(this.inputData, path, value);
    },
    hasViolation(path: string | []): boolean {
      return _.has(this.violations, path);
    },
    getViolation(path: string | []) {
      return _.get(this.violations, path);
    },
    violationAttrs(path: string | []) {
      return {
        type: {
          "is-danger": this.hasViolation(path)
        },
        message: this.getViolation(path)
      };
    },
    fieldValue(path: string | []) {
      return _.get(this.inputData, path);
    },
    async next() {
      let postData: { [key: string]: unknown } = {};
      for (const i in this.inputData) {
        if (_.isPlainObject(this.inputData[i]) && this.inputData[i]["@id"]) {
          postData[i] = this.inputData[i]["@id"];
        } else {
          postData[i] = this.inputData[i];
        }
      }
      if (this.$props.postDataDecorator) {
        postData = await this.$props.postDataDecorator(
          postData,
          this.inputData
        );
      }
      // console.log(postData);

      switch (this.phase) {
        case "input": {
          this.isLoading = true;
          this.violations = {};
          try {
            await this.$store.dispatch("post", [this.validatePath, postData]);
            this.$emit("validatesuccess", this.inputData);
            this.phase = "confirm";
          } catch (violations) {
            for (const v of violations) {
              this.$set(this.violations, v.propertyPath, v.message);
            }
            this.$emit("validatefail", this.inputData, violations);
          }
          this.isLoading = false;
          break;
        }
        case "confirm":
          this.isLoading = true;
          try {
            const ret = await this.$store.dispatch(this.saveMethod, [
              this.savePath,
              postData
            ]);
            this.$emit("savesuccess", ret);
          } catch (ex) {
            alert("登録時にエラーが発生しました");
            this.$emit("savefail", this.inputData);
          }
          this.isLoading = false;
          break;
      }
    },
    async prev() {
      switch (this.phase) {
        case "confirm":
          this.phase = "input";
          break;
      }
    }
  }
});
